"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _merge = _interopRequireDefault(require("lodash/merge"));
var _applicationConfiguration = _interopRequireDefault(require("./application-configuration"));
var _applicationLocalization = _interopRequireDefault(require("./application-localization"));
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
var _default = function _default(applicationContext) {
  var defaults = {
    applicationId: 'prompt',
    applicationName: 'PROMPT',
    applicationConfiguration: _applicationConfiguration.default,
    applicationLocalization: _applicationLocalization.default
  };
  return (0, _merge.default)(defaults, applicationContext);
};
var _default2 = _default;
exports.default = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(_default, "default", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/config/application-context/index.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJhcHBsaWNhdGlvbkNvbnRleHQiLCJkZWZhdWx0cyIsImFwcGxpY2F0aW9uSWQiLCJhcHBsaWNhdGlvbk5hbWUiLCJhcHBsaWNhdGlvbkNvbmZpZ3VyYXRpb24iLCJhcHBsaWNhdGlvbkxvY2FsaXphdGlvbiIsIm1lcmdlIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbmZpZy9hcHBsaWNhdGlvbi1jb250ZXh0L2luZGV4LmpzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBtZXJnZSBmcm9tICdsb2Rhc2gvbWVyZ2UnO1xuXG5pbXBvcnQgYXBwbGljYXRpb25Db25maWd1cmF0aW9uIGZyb20gJy4vYXBwbGljYXRpb24tY29uZmlndXJhdGlvbic7XG5pbXBvcnQgYXBwbGljYXRpb25Mb2NhbGl6YXRpb24gZnJvbSAnLi9hcHBsaWNhdGlvbi1sb2NhbGl6YXRpb24nO1xuXG5leHBvcnQgZGVmYXVsdCAoYXBwbGljYXRpb25Db250ZXh0KSA9PiB7XG5cdGNvbnN0IGRlZmF1bHRzID0ge1xuXHRcdGFwcGxpY2F0aW9uSWQ6ICdwcm9tcHQnLFxuXHRcdGFwcGxpY2F0aW9uTmFtZTogJ1BST01QVCcsXG5cdFx0YXBwbGljYXRpb25Db25maWd1cmF0aW9uLFxuXHRcdGFwcGxpY2F0aW9uTG9jYWxpemF0aW9uLFxuXHR9O1xuXG5cdHJldHVybiBtZXJnZShkZWZhdWx0cywgYXBwbGljYXRpb25Db250ZXh0KTtcbn07XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTtBQUVBO0FBQ0E7QUFBaUU7RUFBQTtFQUFBO0FBQUE7QUFBQTtFQUFBO0FBQUE7QUFBQSxlQUVsRCxrQkFBQ0Esa0JBQWtCLEVBQUs7RUFDdEMsSUFBTUMsUUFBUSxHQUFHO0lBQ2hCQyxhQUFhLEVBQUUsUUFBUTtJQUN2QkMsZUFBZSxFQUFFLFFBQVE7SUFDekJDLHdCQUF3QixFQUF4QkEsaUNBQXdCO0lBQ3hCQyx1QkFBdUIsRUFBdkJBO0VBQ0QsQ0FBQztFQUVELE9BQU8sSUFBQUMsY0FBSyxFQUFDTCxRQUFRLEVBQUVELGtCQUFrQixDQUFDO0FBQzNDLENBQUM7QUFBQTtBQUFBO0FBQUE7QUFBQTtFQUFBO0VBQUE7SUFBQTtFQUFBO0VBQUE7QUFBQTtBQUFBO0FBQUE7RUFBQTtFQUFBO0FBQUEifQ==